import { render, staticRenderFns } from "./ProjectPackage.vue?vue&type=template&id=c9dd307e&scoped=true&"
import script from "./ProjectPackage.vue?vue&type=script&lang=js&"
export * from "./ProjectPackage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPackage.vue?vue&type=style&index=0&id=c9dd307e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dd307e",
  null
  
)

export default component.exports